<template>
  <div class="template-warp">
    <el-menu :default-active="doctorId ? '2' : '1'" mode="horizontal" @select="handleSelect">
      <template v-for="item in tabList">
        <el-menu-item :index="item.type">{{ item.name }}</el-menu-item>
      </template>
      <!-- <el-menu-item :index="'1'">经典处方</el-menu-item> -->
    </el-menu>
    <div class="template-content">
      <!-- 条件查询 -->
      <el-form inline :model="searchForm" class="search" @keydown.native.enter="e => e.preventDefault()">
        <el-form-item label="处方名称">
          <el-input v-model="searchForm.name" placeholder="请输入处方名称" @keydown.native.enter="search" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="content-warp">
        <div class="type-warp">
          <div class="warp-title">模版类型</div>
          <div class="list-warp">
            <vuedraggable :options="dragOptions" forceFallback="true" fallbackClass="fallbackClass" v-model="typeList"
              delay="200" @end="typeListDraggableEnd">
              <div class="list-item" :class="activeTypeId == item.recipeTemplateTypeId ? 'type-active' : ''"
                v-for="(item, i) in typeList" :key="item.recipeTemplateTypeId" :index="String(i + 1)"
                @click="changeActiveType(item.recipeTemplateTypeId)">
                <div>{{ item.recipeTemplateTypeName }}</div>
                <div class="action" v-show="(![0,-1].includes(deptId) && pageFlag == '2') || [0,-1].includes(deptId)">
                  <i @click="editType(item)" class="el-icon-edit-outline mr6"></i>
                  <i @click="deleteType(item)" class="el-icon-delete"></i>
                </div>
              </div>
            </vuedraggable>
          </div>
          <div class="add-warp" @click="addType" v-show="pageFlag == '2'"><i class="el-icon-plus"></i> 新增模版类型</div>
        </div>
        <div class="type-warp">
          <div class="warp-title">处方名称</div>
          <div class="list-warp">
            <vuedraggable forceFallback="true" fallbackClass="fallbackClass" v-model="recipeList" delay="200"
              @end="recipeListDraggableEnd">
              <div class="list-item" :class="activeRecipeId == item.recipeTemplateId ? 'active' : ''"
                v-for="(item, i) in recipeList" :key="item.recipeTemplateId" :index="String(i + 1)"
                @click="changeActive(item.recipeTemplateId)">
                <div class="flex just-b w100_ ">
                  <div>{{ item.recipeTemplateName }}</div>
                  <div class="size12 color667 flex-sh ml4">{{ item.type == '0' ? '中药' : '理疗' }}</div>
                </div>
              </div>
            </vuedraggable>
          </div>
          <div class="add-warp" @click="addRecipe" v-show="pageFlag == '2' && typeList.length > 0"><i
              class="el-icon-plus"></i> 新增处方模版</div>
        </div>
        <div class="recipe-warp" v-if="recipeInfo && recipeInfo.recipeTemplateName">
          <div class="warp-title display-f just-b">
            <div>{{ recipeInfo.recipeTemplateName }}</div>
            <div>
              <el-button type="primary" v-show="(![0,-1].includes(deptId)&& pageFlag == '2') || [0,-1].includes(deptId)"
                @click="editRecipe">编辑</el-button>
              <el-button type="danger" plain v-show="(![0,-1].includes(deptId) && pageFlag == '2') || [0,-1].includes(deptId)"
                @click="delRecipe">删除</el-button>
            </div>
          </div>
          <div class="recipe-content">
            <div class="content-desc">
              <div class="desc-label">名称</div>
              <div class="desc-value">{{ recipeInfo.recipeTemplateName }}</div>
            </div>
            <div class="content-desc">
              <div class="desc-label">源于</div>
              <div class="desc-value">{{ recipeInfo.origin }}</div>
            </div>
            <div class="content-desc">
              <div class="desc-label">功用</div>
              <div class="desc-value">{{ recipeInfo.effect }}</div>
            </div>
            <div class="content-desc">
              <div class="desc-label">主治</div>
              <div class="desc-value">{{ recipeInfo.attending }}</div>
            </div>
            <!-- <div class="content-desc">
              <div class="desc-label">类型</div>
              <div class="desc-value">{{ recipeInfo.type == 0 ? "中药处方" : "理疗处方" }}</div>
            </div> -->
            <!-- <div class="content-desc" v-if="recipeInfo.type == 1">
              <div class="desc-label">理疗法</div>
              <div class="desc-value">{{ recipeInfo.physioKindName }}</div>
            </div> -->
            <div class="content-desc">
              <div class="desc-label">加减法</div>
              <div class="desc-value">{{ recipeInfo.method }}</div>
            </div>
            <div class="content-desc">
              <div class="desc-label">建议</div>
              <div class="desc-value">{{ recipeInfo.suggestion }}</div>
            </div>
          </div>
          <div class="recipe-detail" v-if="recipeInfo">
            <div class="recipeInfo-warp-title">处 方 明 细</div>
            <div class="detail-list" v-if="recipeInfo.type == 0">
              <div class="list-item" v-for="item in recipeInfo.recipeTemplateDrugs" :key="item.spuId">
                <div class="display-f just-b fwb">
                  <div>{{ item.spuCommonName }}</div>
                  <div>{{ item.number }} {{ item.unit }}</div>
                </div>
                <div class="color6671 mt4 h15">
                  <span v-if="item.isOwned && item.isOwned == '1'">【自备】</span>
                  <span>{{ item.handling }}</span>
                </div>
              </div>
            </div>
            <div v-if="recipeInfo && recipeInfo.type == 0" class="recipe-used">
              <span v-if="recipeInfo.recipeMethod">{{ recipeInfo.doseNum }}剂，</span>
              <span v-if="recipeInfo.recipeMethod">{{ recipeInfo.recipeMethod }}</span>
              <span v-if="recipeInfo.doseFrequency">，{{ recipeInfo.doseFrequency }}</span>
              <span v-if="recipeInfo.frequency">，{{ recipeInfo.frequency }}</span>
              <span v-if="recipeInfo.takingDosage">，{{ recipeInfo.takingDosage }}</span>
              <span v-if="recipeInfo.mixingBagNum">，每次{{ recipeInfo.mixingBagNum }}袋</span>
              <span v-if="recipeInfo.creamDosage">，{{ recipeInfo.creamDosage }}</span>
              <span v-if="recipeInfo.pelletizingDosage">，{{ recipeInfo.pelletizingDosage }}</span>
              <span v-if="recipeInfo.bakingPowderDosage">，{{ recipeInfo.bakingPowderDosage }}</span>
              <span v-if="recipeInfo.takingDays">，{{ recipeInfo.takingDays }}</span>
              <span v-if="recipeInfo.recipeMoment">，{{ recipeInfo.recipeMoment }}</span>
              <span v-if="recipeInfo.applicationTime">，{{ recipeInfo.applicationTime }}</span>
              <span v-if="recipeInfo.wrapTime">，{{ recipeInfo.wrapTime }}</span>
              <span v-if="recipeInfo.remark">，{{ recipeInfo.remark }}</span>
            </div>
            <div v-if="recipeInfo.type == 1 && recipeInfo.recipeTemplateDrugs" class="phy-list">
              <div class="phy-item" v-for="(phyItem, phyIndex) in recipeInfo.recipeTemplateDrugs">
                <div class="phy-title">项目{{ phyIndex + 1 }}：{{ phyItem.spuCommonName }}</div>
                <div class="phy-acupoint"
                  v-if="phyItem.acupointinfoList && phyItem.acupointinfoList.length > 0">{{
                    computeAcupoint(phyIndex) }}</div>
                <div class="phy-desc">
                  <div>{{ phyItem.soldNum }}次</div>
                  <div class="ml8"
                    v-if="phyItem.executionMode == 20 && phyItem.onlyNum">
                    1次{{ phyItem.onlyNum }}组</div>
                  <div class="ml8">{{ phyItem.executeDesc }}</div>
                </div>
                <div v-if="phyItem.remark" class="phy_remark">
                  <div>理疗备注:{{ phyItem.remark }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增或编辑弹框 类别 -->
    <el-dialog :title="typeTitle" :visible.sync="typeVisible" width="400px"
      :before-close="done => $handleClose(done, 'editTypeForm')" :close-on-click-modal="false">
      <el-form :model="editTypeForm" ref="editTypeForm" inline :rules="rules">
        <el-form-item label="类型名称" prop="recipeTemplateTypeName">
          <el-input v-model="editTypeForm.recipeTemplateTypeName" placeholder="请输入模板类型名称" />
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="success" v-if="typeTitle == '新增类型'" @click="typeAddSave">保存新增</el-button>
        <el-button type="success" v-if="typeTitle == '编辑类型'" @click="typeEditSave">保存修改</el-button>
        <el-button @click="typeVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增或编辑弹框 模板 -->
    <addTemplateDialog v-if="recipeVisible" :drugOftenUsageList="drugOftenUsageList"
      :recipeTypeAction="recipeTypeAction" :doctorId="doctorId" :form="editRecipeForm" :recipeType="pageFlag"
      :dialogShow="recipeVisible" :title="recipeTitle" @templateCancel="templateCancel" @saveSuceess="saveSuceess">
    </addTemplateDialog>

  </div>
</template>

<script>
import {
  typeList, typeEdit, typeAdd, recipeList,
  recipeEdit, recipeAdd, recipeInfo, recipeDelete, getType
} from "@/api/prescription"; // 处方模板请求
import { acupointList } from "@/api/acupoint"; // 穴位请求
import { isNull, checkReg, dictText } from '@/utils/validateBase';
import { prescriptionDTO } from '@/DTO/index'
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { DRUG_TYPE } from '@/utils/const'
import { positiveInteger } from '@/utils/regexp';
import { CommonDTO } from '@/DTO'
import addTemplateDialog from './addTemplateDialog'
import { Outpatient } from '../DoctorWorkstation/newDiagnosis/data/index.js'
import { isEmptyArray } from "../../utils/validateBase";
export default {
  // 定义引入的组件
  components: { vuedraggable, addTemplateDialog, vuedraggable },
  props: {},
  data() {
    let checkPositiveInteger = (rule, value, callback) => {
      if (!checkReg(positiveInteger, value)) {
        return callback(new Error(`请输入正整数`));
      }
      return callback();
    }
    return {
      deptId: this.$session.get('deptId'),
      defaultActive: '1',
      loading: true, // 加载
      pageFlag: "2", // 类型切换
      searchForm: {
        name: null // 处方名称
      }, // 查询表单
      typeList: [], // 处方类别列表
      recipeList: [], // 处方列表
      activeTypeId: null, // 激活类型id
      activeRecipeId: null, // 激活处方id
      recipeInfo: {}, // 激活处方详情
      editTypeForm: {}, // 类型表单
      editRecipeForm: {}, // 处方表单
      typeTitle: null, // 类型模态框标题
      typeVisible: false, // 类型模态框状态
      recipeTitle: null,// 处方模态框标题
      recipeVisible: false, // 处方模态框状态
      acupointOptions: [], // 穴位列表
      physioOptions: [], // 理疗列表
      handlingOptions: this.$handlingOptions, // 特殊煎法
      speciesOptions: this.$speciesOptions, // 所在经脉选项
      species: "", // 所在经脉
      drugType: DRUG_TYPE, // 药品类型
      doctorId: this.$session.get("user").hospDoctorInfo.doctorId, // 医生id
      rules: {
        recipeTemplateTypeName: [{ required: true, message: '模板类型名称不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '模板类型显示顺序不能为空', trigger: 'blur' }, { validator: checkPositiveInteger, trigger: 'blur' }],
      },
      draggableDisabled: false,
      deptOptions: [], // 医馆列表
      dragOptions: {
        animation: 200,
        // draggable: '.recipeTemplateTypeName',
        filter: '.action',
        // preventOnFilter: true,
      },
      drugOftenUsageList: [],
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
      tabList: []
    }
  },
  //变量监听
  watch: {},
  computed: {
    computeDept() {
      let that = this;
      return function (id) {
        return dictText(id, that.deptOptions)
      }
    },
    computeDeptName() {
      let that = this;
      return function (list) {
        let st = '';
        if (!_.isEmpty(list)) {
          list.forEach(v => {
            st += dictText(v, that.deptOptions) + ','
          })
        }
        return st
      }
    },
    computeAcupoint() {
      let that = this;
      const SiFenLeft = [
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ]
      const SiFenRight = [
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ]
      return function (phyIndex) {
        let str = ''
        if (!isNull(that.recipeInfo.recipeTemplateDrugs)) {
          let phyItem = that.recipeInfo.recipeTemplateDrugs[phyIndex]
          phyItem.acupointinfoList && phyItem.acupointinfoList.forEach(v => {
            if (v.type == 60) {
              let left = ''
              let leftFlag = false
              let right = ''
              let rightFlag = false
              v.typeExtend.forEach(v1 => {
                SiFenLeft.forEach(v2 => {
                  if (v1 == v2.value) {
                    leftFlag = true
                    left = left + v2.label + '、'
                  }
                })
                SiFenRight.forEach(v2 => {
                  if (v1 == v2.value) {
                    rightFlag = true
                    right = right + v2.label + '、'
                  }
                })
              })
              left = left.slice(0, -1)
              right = right.slice(0, -1)
              str = str + `【${v.typeExtend.length}】${v.acupointName}(${leftFlag ? '左手：' : ''}${left} ${rightFlag ? '右手：' : ''}${right})、`
            } else if (v.type == 50) {
              str = str + `【${v.typeExtend[0]}】${v.acupointName}、`
            } else {
              str = str + `【${dictText(v.type, that.acupointType)}】${v.acupointName}、`
            }
          })
        }
        str = str.slice(0, -1);
        return str
      }
    }
  },
  // 页面初始化
  async created() {
    await this.getType()
    this.getTypeList(0); // 获取类别
    this.getAcupointsList(); // 获取穴位列表
    this.getDeptList()
    this.getOftenUsage()
  },
  // 页面DOM加载完成
  mounted() {
  },
  //离开页面时执行
  destroyed() { },
  methods: {
    // 获取医生常用用法
    async getOftenUsage() {
      const oftenUsage = await Outpatient.getOftenUsage()
      this.drugOftenUsageList = oftenUsage || []
    },
    //获取所有的场馆
    async getDeptList() {
      this.deptOptions = await CommonDTO.getDeptListDTO();
    },
    // 获取处方类别
    async getTypeList(doctorId, data) {
      let { total, rows, code } = await typeList({ doctorId: doctorId, recipeType: this.pageFlag });
      if (code == 200) {
        this.typeList = rows;
        if (total > 0) {
          this.activeTypeId = isNull(data) ? rows[0].recipeTemplateTypeId : data
          if (this.activeTypeId == null && total > 0) {
            this.getRecipeList();
          } else if (this.activeTypeId != null) {
            this.getRecipeList();
          } else this.recipeInfo = null;
        } else{
          this.recipeInfo = null
        }
      }
      this.loading = false;
    },
    // 获取处方列表
    async getRecipeList(search, data, index) {
      let { total, rows, code } = await recipeList({ recipeTemplateTypeId: this.activeTypeId, ...this.searchForm, recipeType: this.pageFlag });
      if (code == 200) {
        if (total >= 0) {
          this.recipeList = rows;
          if (total > 0) {
            if (data != undefined) {
              this.activeRecipeId = data;
              rows.forEach((item, index) => {
                if (item.recipeTemplateId == data) this.defaultActive = String(index + 1);
              });
              this.getRecipeInfo();
            } else if (index != undefined) {
              this.defaultActive = index;
              this.activeRecipeId = rows[0].recipeTemplateId;
              this.getRecipeInfo();
            } else if (this.activeRecipeId != null) {
              this.getRecipeInfo();
            } else if (this.activeRecipeId == null) {
              this.activeRecipeId = rows[0].recipeTemplateId;
              this.getRecipeInfo();
            }
          } else this.recipeInfo = null;
        }
      }
      this.loading = false;
    },
    // 获取处方详情
    async getRecipeInfo() {
      if (this.activeRecipeId) {
        let { code, data } = await recipeInfo(this.activeRecipeId);
        if (code == 200) {
          this.recipeInfo = data;
        }
      } else this.recipeInfo = null;
      this.loading = false;
    },
    // 请求穴位列表
    async getAcupointsList() {
      let { rows, code } = await acupointList();
      if (code == 200) this.acupointOptions = rows;
    },
    // 切换激活类型
    changeActiveType(id) {
      this.activeTypeId = id;
      this.activeRecipeId = null;
      this.defaultActive = '1';
      this.getRecipeList();
    },
    // 切换激活药方
    changeActive(id) {
      this.activeRecipeId = id;
      this.getRecipeInfo();
    },
    // 切换处方类型
    changeRecipeType(val) {
      if (val == '1') this.editRecipeForm.acupointOptions = JSON.parse(JSON.stringify(this.acupointOptions));
      else this.editRecipeForm.acupointOptions = [];
    },
    // 新增处方
    addRecipe() {
      this.editRecipeForm = {
        doseType: '0', attending: null, effect: null, method: null, origin: null, recipeTemplateName: null, type: null, suggestion: null,
        recipeTemplateTypeId: this.activeTypeId, drugOptions: [], recipeTemplateDrugs: null, acupointIds: [],
        acupointOptions: {}, recipeType: this.pageFlag, doseNum: '1', recipeMethod: '煎服',//煎法
        recipeMoment: '',//服用时机
        frequency: '',
        takingDosage: '',
        takingDays: '',
        applicationTime: '',
        wrapTime: '',
        bakingPowderDosage: '',
        creamDosage: '',
        pelletizingDosage: '',
        doseFrequency: '',
        remark: '',
        mixingBagNum: '1',//冲服
      }
      this.recipeTitle = "新增模板";
      this.recipeTypeAction = 'add'
      this.recipeVisible = true;
    },
    // 编辑处方
    editRecipe() {
      this.editRecipeForm = {
        doseType: '中药饮片', attending: null, effect: null, method: null, origin: null, recipeTemplateName: null, recipeTemplateId: null, suggestion: null,
        type: null, recipeTemplateTypeId: this.activeTypeId, drugOptions: [], recipeTemplateDrugs: [], acupointIds: [],
        acupointOptions: {}, recipeType: this.pageFlag, doseNum: '1', recipeMethod: '煎服',//煎法
        recipeMoment: '',//服用时机
        frequency: '',
        takingDosage: '',
        takingDays: '',
        applicationTime: '',
        wrapTime: '',
        bakingPowderDosage: '',
        creamDosage: '',
        pelletizingDosage: '',
        doseFrequency: '',
        remark: '',
        mixingBagNum: '1',//冲服
      }
      let form = this.editRecipeForm, data = this.recipeInfo;
      // 基础数据处理
      for (let key in form) {
        for (let keys in data) {
          if (key == keys) form[key] = data[keys];
        }
      }
      this.recipeTitle = "编辑模板";
      this.recipeTypeAction = 'edit'
      this.recipeVisible = true;
    },
    // 删除处方
    delRecipe() {
      this.$confirm('确认删除该处方？').then(_ => { this.del(this.recipeInfo.recipeTemplateId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await recipeDelete(id);
      if (code == 200) this.$message.success("删除处方成功！");

      this.loading = true;
      this.activeRecipeId = null;
      this.getRecipeList({}, undefined, "1");
    },
    // 新增类型
    addType() {
      this.editTypeForm = { recipeTemplateTypeName: null, recipeType: this.pageFlag, sort: 1, isYlcp: 0 };
      this.typeTitle = "新增类型";
      this.typeVisible = true;
    },
    // 保存新增
    typeAddSave() {
      this.$refs.editTypeForm.validate(async (valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.editTypeForm));
          let { code, data } = await typeAdd(params);
          if (code == 200) {
            this.$message.success("新增类型成功！");
            this.typeVisible = false;
            this.getTypeList('', data);
          }
          this.loading = true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    // 编辑类型
    editType(row) {
      this.editTypeForm = row;
      this.typeTitle = "编辑类型";
      this.typeVisible = true;
    },
    // 保存编辑
    async typeEditSave() {
      this.$refs.editTypeForm.validate(async (valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.editTypeForm));
          let { code, data } = await typeEdit(params);
          if (code == 200) this.$message.success("修改类型成功！");
          this.typeVisible = false;
          this.loading = true;
          this.getTypeList('', data.recipeTemplateTypeId);
          // this.getRecipeList('',data.recipeTemplateTypeId);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 刷新
    refresh() {
      this.loading = true;
      if (this.pageFlag == 2) this.getTypeList(0);
      else this.getTypeList(null);
    },
    // 切换模板类型
    handleSelect(e) {
      this.pageFlag = e;
      this.activeTypeId = null;
      this.typeList = [];
      this.recipeList = [];
      this.activeRecipeId = null;
      this.refresh();
    },
    // 搜索
    search() {
      this.loading = true;
      this.getRecipeList(this.searchForm);
    },
    // 重置
    reset() {
      this.searchForm = { name: null }
      this.getRecipeList();
    },
    //删除处方模版类型
    async deleteType(item) {
      let { code, data } = await prescriptionDTO.deleteType(item.recipeTemplateTypeId)
      if (code == 200) {
        this.$message.success('删除成功')
        this.refresh()
      }
    },
    /**
     * 新增模版取消
     */
    templateCancel() {
      this.recipeVisible = false
    },
    /**
     * 处方模版保存
     */
    saveSuceess(data) {
      this.templateCancel()
      this.getTypeList('', this.activeTypeId)
      // this.getRecipeList({}, data);
    },
    /**
     * 模版类型拖拽结束
     */
    typeListDraggableEnd() {
      let recipeTemplateTypeIds = []
      this.typeList.forEach(obj => {
        recipeTemplateTypeIds.push(obj.recipeTemplateTypeId)
      })
      prescriptionDTO.resetSort({ recipeType: this.pageFlag, recipeTemplateTypeIds }).then(res => {
        if (res.code == 200) {
          this.refresh()
        }
      })
    },
    /**
     * 处方名称拖拽结束
     */
    recipeListDraggableEnd() {
      let recipeTemplateIds = []
      this.recipeList.forEach(obj => {
        recipeTemplateIds.push(obj.recipeTemplateId)
      })
      prescriptionDTO.recipeResetSort({ recipeTemplateTypeId: this.activeTypeId, recipeTemplateIds }).then(res => {
        if (res.code == 200) {
          this.getRecipeList()
        }
      })
    },
    async getType() {
      let { code, data } = await getType();
      if (code == 200) {
        if (data && !isEmptyArray(data)) {
          if (isNull(this.doctorId)) {
            let index = data.findIndex(item => item.type == '2')
            data.splice(index, 1)
          }
          this.tabList = data || [];
          this.pageFlag = isNull(this.doctorId) ? '1' : '2'
        }
      }
    },
  }
}
</script>
<style lang="less" scoped>
.template-warp {
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .template-content {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .content-warp {
      font-size: 14px;
      color: #1F2329;
      flex: 1;
      overflow: hidden;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #D3D3D5;
      display: flex;

      .warp-title {
        line-height: 40px;
        padding: 0 12px;
        box-sizing: border-box;
        background: #F0F1F3;
      }

      .type-warp {
        width: 230px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border-left: 1px solid #D3D3D5;
        border-right: 1px solid #D3D3D5;
        cursor: pointer;

        &:first-child {
          margin-right: 8px;
          border-left: none;
          border-right: 1px solid #D3D3D5;
        }

        .list-warp {
          flex: 1;
          overflow: auto;
          border-top: 1px solid #D3D3D5;

          .list-item {
            width: 100%;
            padding: 0 12px;
            min-height: 40px;
            line-height: 20px;
            border-bottom: 1px solid #D3D3D5;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;

            &:last-child {
              border-bottom: none;
            }
          }

          .type-active {
            color: #1890FF;
          }

          .active {
            color: #1890FF;
            background: #E8F4FF;
          }
        }

        .add-warp {
          line-height: 36px;
          text-align: center;
          cursor: pointer;
          border-top: 1px solid #D3D3D5;
        }
      }

      .recipe-warp {
        border: 1px solid #D3D3D5;
        border-radius: 0px 2px 0px 0px;
        border-top: none;
        border-bottom: none;
        margin-left: 10px;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .recipe-content {
          .content-desc {
            display: flex;
            min-height: 40px;
            border-top: 1px solid #D3D3D5;
            background: #F7F8F9;

            &:last-child {
              border-bottom: 1px solid #D3D3D5;
            }

            .desc-label {
              flex-grow: 0;
              flex-shrink: 0;
              width: 96px;
              line-height: 40px;
              border-right: 1px solid #D3D3D5;
              padding-left: 12px;
              box-sizing: border-box;
            }

            .desc-value {
              line-height: 40px;
              padding-left: 12px;
              box-sizing: border-box;
            }
          }


        }

        .recipe-detail {
          overflow: auto;
          margin-top: 8px;
          border-top: 1px solid #D3D3D5;
          padding-bottom: 10px;

          .recipeInfo-warp-title {
            line-height: 40px;
            padding: 0 12px;
            box-sizing: border-box;
            background: #F0F1F3;
            border-bottom: 1px solid #D3D3D5;
          }

          .detail-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            background: #F9F9FA;

            .list-item {
              border-right: 1px dashed #D3D3D5;
              border-bottom: 1px dashed #D3D3D5;
              padding: 12px 10px;

              &:nth-child(4n) {
                border-right: none;
              }
            }
          }

          .recipe-used {
            line-height: 37px;
            background: #F7F8F9;
            padding-left: 10px;
            border-top: 1px dashed #D3D3D5;
            border-bottom: 1px solid #D3D3D5;
          }

          .phy-list {
            background: #F7F8F9;

            .phy-item {
              border-bottom: 1px solid #D3D3D5;

              &:last-child {
                border-bottom: none;
              }

              .phy-title {
                height: 40px;
                line-height: 40px;
                padding-left: 12px;
                color: #000;
                font-size: 14px;
                font-weight: 500;
                border-bottom: 1px dashed #D3D3D5;
                box-sizing: border-box;
              }

              .phy-acupoint {
                min-height: 40px;
                line-height: 40px;
                padding-left: 12px;
                color: #000;
                font-size: 14px;
                font-weight: 400;
                border-bottom: 1px dashed #D3D3D5;
                box-sizing: border-box;
              }

              .phy-desc {
                display: flex;
                align-items: center;
                height: 40px;
                padding-left: 12px;
                color: #000;
                font-size: 14px;
                font-weight: 400;
                box-sizing: border-box;
              }
            }

          }
        }
      }
    }
  }

  .drugTable {
    border: 1px solid #ebeaee;

    // box-sizing:border-box;
    .drugTable-head {
      display: flex;
      background: #F0F1F3;
    }

    .drugTable-row {
      display: flex;
      border-bottom: 1px solid #ebeaee;

      &:last-child {
        border-bottom: none;
      }
    }

    .row-item {
      width: 80px;
      display: flex;
      align-items: center;
      border-right: 1px solid #ebeaee;
      box-sizing: border-box;
      padding: 0 10px;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .fallbackClass {
    background: #eff3f6;
  }
}

.phy_remark {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 12px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  border-top: 1px dashed #D3D3D5;
}
</style>